import React from 'react';
import {
  DialogContent,
  DialogActions,
  Button, Box,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSelector } from 'react-redux';
import Dialog from '../../../components/atoms/Dialog';

export default function ConfirmDialog(props) {
  const isLoading = useSelector((state) => state.commonStore.isLoading);
  const {
    onClick,
    open,
    onClose,
    title,
    content,
    actionName,
    isError,
  } = props;

  return (
    <Dialog isOpen={open} onClose={onClose} title={title} isError={isError}>
      <DialogContent dividers>
        <Box>{content}</Box>
        <Box>よろしいですか？</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">キャンセル</Button>
        <LoadingButton
          onClick={onClick}
          loading={isLoading}
          color={isError ? 'secondary' : 'primary'}
        >
          {actionName}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
